import type ProgressBar from '../../console/progressBar.js';
import Package from '../../globals/package.js';
import type DAT from '../../models/dats/dat.js';
import Header from '../../models/dats/logiqx/header.js';
import LogiqxDAT from '../../models/dats/logiqx/logiqxDat.js';
import ArrayUtil from '../../utils/arrayUtil.js';
import DateUtil from '../../utils/dateUtil.js';
import Module from '../module.js';

/**
 * Combine every {@link DAT} into a single {@link DAT}.
 */
export default class DATCombiner extends Module {
  constructor(progressBar: ProgressBar) {
    super(progressBar, DATCombiner.name);
  }

  /**
   * Combine the DATs.
   */
  combine(dats: DAT[]): DAT {
    this.prefixedLogger.trace(`combining ${dats.length} DAT${dats.length === 1 ? '' : 's'}`);

    const games = dats
      .flatMap((dat) => dat.getGames())
      .filter(ArrayUtil.filterUniqueMapped((game) => game.hashCode()));

    // Preserve MAME provenance so that consumers relying on {@link DAT.isMame} (e.g. raw archive
    // checksumming decisions) continue to treat the combined DAT as MAME-derived
    const isMame = dats.some((dat) => dat.isMame());

    const newDat = new LogiqxDAT({
      header: DATCombiner.generateHeader(dats),
      ...(isMame ? { machine: games } : { games }),
    });

    this.prefixedLogger.trace(`done combining ${dats.length} DAT${dats.length === 1 ? '' : 's'}`);
    return newDat;
  }

  private static generateHeader(dats: DAT[]): Header {
    const datName = 'igir combined';
    const date = DateUtil.format('YYYYMMDD-HHmmss');
    return new Header({
      name: datName,
      description: datName,
      version: date,
      date,
      author: Package.NAME,
      url: Package.HOMEPAGE,
      comment: [
        `Combined DAT generated by ${Package.NAME} v${Package.VERSION}`,
        ...dats.map((dat) => dat.getName()),
      ].join('\n'),
    });
  }
}
